var _IconClose;

var _excluded = ["role", "closeButtonAriaLabel", "children", "onClose", "showCloseButton"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import { backgroundPrimary } from '@salutejs/plasma-core';
import { IconClose } from '@salutejs/plasma-icons';
import { Button } from '../Button';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Modal/ModalView');
var StyledWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma-web-core__sc-92wujm-0"
})(["display:flex;align-items:center;height:100%;"]);
var StyledBody = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma-web-core__sc-92wujm-1"
})(["position:relative;width:25rem;max-width:100%;border-radius:1.25rem;background-color:", ";pointer-events:all;"], backgroundPrimary);
var StyledContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma-web-core__sc-92wujm-2"
})(["padding:2rem;"]);
var StyledButtonClose = /*#__PURE__*/styled(Button({
  design: 'web'
})).attrs(function () {
  return {
    view: 'clear'
  };
}).withConfig({
  componentId: "plasma-web-core__sc-92wujm-3"
})(["position:absolute;top:0;right:0;margin:2rem;width:auto;height:auto;padding:0;"]);
/**
 * Визуальная часть модального окна.
 */

export var ModalView = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'dialog' : _ref$role,
      closeButtonAriaLabel = _ref.closeButtonAriaLabel,
      children = _ref.children,
      onClose = _ref.onClose,
      _ref$showCloseButton = _ref.showCloseButton,
      showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(StyledBody, _extends({}, rest, {
    ref: ref,
    role: role,
    "aria-modal": "true"
  }), /*#__PURE__*/React.createElement(StyledContent, null, children), showCloseButton && /*#__PURE__*/React.createElement(StyledButtonClose, {
    "aria-label": closeButtonAriaLabel,
    onClick: onClose,
    contentLeft: _IconClose || (_IconClose = /*#__PURE__*/React.createElement(IconClose, {
      size: "s",
      color: "inherit"
    }))
  })));
});